import classNames from 'classnames';
import React, { useEffect } from 'react';

import './Callout.scss';

export interface Props {
  isOpen: boolean;
  calloutStyles: React.CSSProperties;
  updateWallpaperPreviewStyles?: () => void;
  ref: any;
  className?: string;
  callback?: () => void;
}

type Ref = HTMLDivElement;

export const Callout: React.FC<Props> = React.forwardRef<Ref, Props>(
  (
    {
      isOpen,
      children,
      calloutStyles,
      updateWallpaperPreviewStyles,
      className,
      callback,
    },
    ref: any
  ) => {
    useEffect(() => {
      callback && callback();
      const coords = ref.current?.getBoundingClientRect();

      if (!coords || !updateWallpaperPreviewStyles) return;

      if (coords.y + coords.height > window.innerHeight) {
        updateWallpaperPreviewStyles();
      }
    }, []);

    return (
      isOpen && (
        <div
          data-testid="callout"
          className={classNames('Callout', className)}
          style={calloutStyles}
          ref={ref}
        >
          <div className="Callout__arrow" />
          {children}
        </div>
      )
    );
  }
);

Callout.displayName = 'Callout';

export default Callout;
